module.exports = __webpack_public_path__ + "static/portrait02-3119c880ca0d95bf443e62021e736d98.png";